
<div mat-dialog-title>Accounts cannot be assigned@if (!showProgressBar) {
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
}</div>
@if (mdd) {
  <div>
    <mat-dialog-content>
      @if (!showProgressBar) {
        <div>
          <mat-card class="warn block">
            <mat-card-title class="warn">Your .csv file includes invalid records</mat-card-title>
            <mat-card-subtitle style="font-family: Arial;font-size: 13px;color: #000000;">The records listed below will
              not get imported
            </mat-card-subtitle>
          </mat-card>
          <div>
            @if (!isUiTest) {
              <irb-inventory-grid (gridReady)="onGridReady($event)"
                [frameworkComponents]='frameworkComponents'
                [gridOptions]="gridOptions"
                [rowData]='mdd.invalidRecords'
                [showSideBar]="false"
                [style.height]="'240px'"
              [style.width]="'100%'"></irb-inventory-grid>
            }
          </div>
        </div>
      }
      @if (showProgressBar) {
        <div class="dialog-body flex progress-bar">
          <irb-progress-bar [progressValue]="progressBarValue"></irb-progress-bar>
        </div>
      }
    </mat-dialog-content>
    <mat-dialog-actions>
      <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel entire import</button>
      <button id="continueButton" (click)="completeImport()" [disabled]="!(mdd.validRecords && mdd.validRecords === true)" class="btn-medium-primary">Finish</button>
    </mat-dialog-actions>
  </div>
}
